// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__DDZTn","dragIcon":"SortableItem_dragIcon__3P8Hs","disabled":"SortableItem_disabled__1fjp6"};